export function timestampToSeconds(timestamp) {
  return timestamp.split(':').map(t => t * 60).reduce((acc, val) => (acc + val));
}